
/**
 * @import internal modules
 */

/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';
import * as Utils from '@root-utils/index';


// component
const Component: React.FunctionComponent<any> = (props: InterfaceHeader<string>): JSX.Element =>{
    
    const { classnames ,onOpenModal, timerShow } = props;
    
    const [date, setDate] = React.useState("00:00:00");
 
    React.useEffect(() => {
    const timerID = setInterval( () => tick(), 1000 );
    
        return function cleanup() {
            clearInterval(timerID);
        };
    });
    
    function tick() {
        setDate(Utils.onClockUtils());
    }

    return(
        <div className={classnames} >
        
            <div className="header">
                <div className="header-left left"><span className="nameCustomer">DEMO TOLLSENSE</span></div>
                <div className="header-right left">
                <p>
                    {timerShow && <span className="tools-top">
                        <span className="user-header" > {date}</span> 
                    </span>}
                    <span className="help" onClick={onOpenModal}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.44043 8.19727C2.44954 7.65495 2.51107 7.22656 2.625 6.91211C2.73893 6.59766 2.97135 6.24902 3.32227 5.86621L4.21777 4.94336C4.60059 4.51042 4.79199 4.04557 4.79199 3.54883C4.79199 3.07031 4.66667 2.69661 4.41602 2.42773C4.16536 2.1543 3.80078 2.01758 3.32227 2.01758C2.85742 2.01758 2.48372 2.14062 2.20117 2.38672C1.91862 2.63281 1.77734 2.96322 1.77734 3.37793H0.512695C0.52181 2.63965 0.783854 2.04492 1.29883 1.59375C1.81836 1.13802 2.49284 0.910156 3.32227 0.910156C4.18359 0.910156 4.85352 1.14258 5.33203 1.60742C5.8151 2.06771 6.05664 2.70117 6.05664 3.50781C6.05664 4.30534 5.6875 5.09147 4.94922 5.86621L4.2041 6.60449C3.87142 6.97363 3.70508 7.50456 3.70508 8.19727H2.44043ZM2.38574 10.3643C2.38574 10.1592 2.44727 9.98828 2.57031 9.85156C2.69792 9.71029 2.88477 9.63965 3.13086 9.63965C3.37695 9.63965 3.5638 9.71029 3.69141 9.85156C3.81901 9.98828 3.88281 10.1592 3.88281 10.3643C3.88281 10.5693 3.81901 10.7402 3.69141 10.877C3.5638 11.0091 3.37695 11.0752 3.13086 11.0752C2.88477 11.0752 2.69792 11.0091 2.57031 10.877C2.44727 10.7402 2.38574 10.5693 2.38574 10.3643Z" fill="url(#paint0_linear)"/>
                            <defs>
                                <linearGradient id="paint0_linear" x1="4" y1="-2" x2="4" y2="15" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#028DFF"/>
                                    <stop offset="1" stop-color="#6A11CB"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </span>
                    
                </p>
                </div>
            </div>
        </div>
    )
}
// interface 
export interface InterfaceHeader<T>{
    classnames: T,
    onOpenModal?:any,
    timerShow?:boolean
}
/**
 * DefaultProps values
 */
Component.defaultProps= {

}


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@shared/header/component.tsx